/**
 * Grenade Fit Finder — Motor de recomendación (sync con perfil MG)
 */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-mg-finder]');
  if (!roots.length) return;

  var Prefs = window.MGProfilePrefs;

  function getDataUrl(root) {
    return root.getAttribute('data-mg-finder-url') || window.MG_FINDER_DATA_URL || '';
  }

  function formatCLP(cents) {
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(cents / 100);
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function salesWaNumber() {
    var cfg = window.MG_SALES_ADVISOR || {};
    return String(cfg.number || '19567414430').replace(/\D/g, '');
  }

  function addVariantsToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart add failed');
      return r.json();
    });
  }

  function buildCartPermalink(items) {
    var segment = items
      .map(function (i) { return i.id + ':' + (i.quantity || 1); })
      .join(',');
    return '/cart/' + segment;
  }

  function scoreProduct(product, answers) {
    var goal = answers.goal;
    if (goal === 'strength') goal = 'muscle';
    var s = product.score || 50;
    if (product.goals.indexOf(goal) >= 0) s += 40;
    if (product.levels.indexOf(answers.level) >= 0) s += 15;
    if (product.budgets.indexOf(answers.budget) >= 0) s += 15;
    if (goal === 'value' && product.goals.indexOf('value') >= 0) s += 20;
    return s;
  }

  function urlParams() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (e) {
      return { get: function () { return null; } };
    }
  }

  function buildQuiz(root, data) {
    var state = { step: 0, answers: {}, steps: ['goal', 'level', 'budget'] };
    var quizEl = root.querySelector('.mg-finder__quiz');
    var resultsEl = root.querySelector('.mg-finder__results');
    var progressBar = root.querySelector('.mg-finder__progress-bar');
    var stepLabel = root.querySelector('.mg-finder__step-label');
    var questionEl = root.querySelector('.mg-finder__question');
    var optionsEl = root.querySelector('.mg-finder__options');
    var btnBack = root.querySelector('.mg-finder__btn--back');
    var btnNext = root.querySelector('.mg-finder__btn--next');
    var resultCards = root.querySelector('.mg-finder__result-cards');
    var resultSubtitle = root.querySelector('.mg-finder__result-subtitle');
    var btnRestart = root.querySelector('.mg-finder__restart');
    var prefsBanner = root.querySelector('[data-finder-prefs-banner]');

    var stepConfig = {
      goal: { key: 'goals', q: '¿Cuál es tu objetivo principal?' },
      level: { key: 'levels', q: '¿Cuál es tu nivel de entrenamiento?' },
      budget: { key: 'budgets', q: '¿Cuál es tu presupuesto aproximado?' }
    };

    function applyPrefsToState(answers) {
      if (!answers) return false;
      if (answers.goal) state.answers.goal = answers.goal;
      if (answers.level) state.answers.level = answers.level;
      if (answers.budget) state.answers.budget = answers.budget;
      return !!(state.answers.goal && state.answers.level && state.answers.budget);
    }

    function showPrefsBanner(answers) {
      if (!prefsBanner || !Prefs) return;
      var sum = Prefs.summary(Prefs.load() || { goal: answers.goal, level: answers.level, budget: answers.budget });
      if (!sum) return;

      prefsBanner.hidden = false;
      prefsBanner.innerHTML =
        '<div class="mg-finder__prefs-body">' +
          '<strong>🎯 Perfil detectado</strong>' +
          '<span>' + sum.goal + ' · ' + sum.level + ' · ' + sum.budget + '</span>' +
        '</div>' +
        '<div class="mg-finder__prefs-actions">' +
          '<button type="button" class="mg-finder__btn mg-finder__btn--prefs" data-finder-use-prefs>Usar mi perfil</button>' +
          '<button type="button" class="mg-finder__btn mg-finder__btn--prefs-outline" data-finder-skip-prefs>Empezar de cero</button>' +
        '</div>';

      prefsBanner.querySelector('[data-finder-use-prefs]').addEventListener('click', function () {
        applyPrefsToState(answers);
        prefsBanner.hidden = true;
        var params = urlParams();
        if (params.get('autostart') === '1') {
          showResults();
        } else {
          state.step = 0;
          renderStep();
        }
      });

      prefsBanner.querySelector('[data-finder-skip-prefs]').addEventListener('click', function () {
        prefsBanner.hidden = true;
        state.answers = {};
        state.step = 0;
        renderStep();
      });
    }

    function renderStep() {
      var stepKey = state.steps[state.step];
      var cfg = stepConfig[stepKey];
      var items = data[cfg.key];

      progressBar.style.width = ((state.step + 1) / state.steps.length * 100) + '%';
      stepLabel.textContent = 'Paso ' + (state.step + 1) + ' de ' + state.steps.length;
      questionEl.textContent = cfg.q;
      optionsEl.innerHTML = '';

      items.forEach(function (item) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mg-finder__option' + (state.answers[stepKey] === item.id ? ' is-selected' : '');
        btn.innerHTML =
          '<span class="mg-finder__option-icon">' + (item.icon || '▸') + '</span>' +
          '<span class="mg-finder__option-text"><strong>' + item.label + '</strong><span>' + item.desc + '</span></span>';
        btn.addEventListener('click', function () {
          state.answers[stepKey] = item.id;
          renderStep();
          btnNext.disabled = false;
        });
        optionsEl.appendChild(btn);
      });

      btnBack.disabled = state.step === 0;
      btnNext.textContent = state.step === state.steps.length - 1 ? 'Ver resultados' : 'Siguiente';
      btnNext.disabled = !state.answers[stepKey];
    }

    function showResults() {
      quizEl.classList.add('is-hidden');
      resultsEl.classList.add('is-visible');
      if (prefsBanner) prefsBanner.hidden = true;
      resultCards.innerHTML = '<div class="mg-finder__loading">Calculando tu stack ideal...</div>';

      var goalLabel = (data.goals.find(function (g) { return g.id === state.answers.goal; }) || {}).label || '';
      resultSubtitle.textContent = 'Basado en tu meta: ' + goalLabel;

      if (Prefs) Prefs.fromFinderAnswers(state.answers);

      var ranked = data.products
        .map(function (p) { return { product: p, score: scoreProduct(p, state.answers) }; })
        .sort(function (a, b) { return b.score - a.score; })
        .slice(0, 5);

      Promise.all(ranked.map(function (r) {
        return fetchProduct(r.product.handle).then(function (live) {
          return { rank: r, live: live };
        });
      })).then(function (items) {
        var valid = items.filter(function (item) { return item.live && item.live.available; });
        if (!valid.length) valid = items.filter(function (item) { return item.live; });
        resultCards.innerHTML = '';
        var shown = 0;

        valid.forEach(function (item) {
          shown++;
          var p = item.live;
          var reason = item.rank.product.reason;
          var avail = p.available;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var card = document.createElement('a');
          card.href = '/products/' + p.handle;
          card.className = 'mg-finder__result-card';
          card.innerHTML =
            '<div class="mg-finder__result-img-wrap">' +
              '<span class="mg-finder__result-rank">' + shown + '</span>' +
              '<img src="' + img + '" alt="' + p.title.replace(/"/g, '') + '" loading="lazy">' +
            '</div>' +
            '<div class="mg-finder__result-info">' +
              '<h4>' + p.title + (avail ? '' : ' <small style="color:#888;">(Agotado)</small>') + '</h4>' +
              '<p class="mg-finder__result-reason">' + reason + '</p>' +
              '<span class="mg-finder__result-price">' + formatCLP(p.price) + '</span>' +
            '</div>' +
            '<span class="mg-finder__result-cta">' + (avail ? 'Ver producto' : 'Consultar') + '</span>';
          resultCards.appendChild(card);
        });

        if (shown === 0) {
          var wa = salesWaNumber();
          resultCards.innerHTML =
            '<p style="text-align:center;color:#888;">No hay stock en tus recomendaciones ahora. ' +
            '<a href="https://wa.me/' + wa + '?text=Necesito+asesor%C3%ADa+de+suplementos" style="color:#f5c518;">Escríbenos por WhatsApp</a>.</p>';
        } else {
          var stackItems = valid
            .filter(function (item) { return item.live && item.live.available && item.live.variants && item.live.variants[0]; })
            .slice(0, 3)
            .map(function (item) {
              return { id: item.live.variants[0].id, quantity: 1, title: item.live.title, price: item.live.price };
            });
          if (stackItems.length) {
            var total = stackItems.reduce(function (s, i) { return s + (i.price || 0); }, 0);
            var toolbar = document.createElement('div');
            toolbar.className = 'mg-finder__stack-toolbar';
            toolbar.innerHTML =
              '<p class="mg-finder__stack-summary">Stack sugerido: ' + stackItems.length + ' productos · ' + formatCLP(total) + '</p>' +
              '<div class="mg-finder__stack-actions">' +
                '<button type="button" class="mg-finder__btn mg-finder__btn--stack" data-finder-add-stack>Agregar stack al carrito</button>' +
                '<button type="button" class="mg-finder__btn mg-finder__btn--wa" data-finder-wa-stack>Consultar por WhatsApp</button>' +
              '</div>';
            resultCards.insertBefore(toolbar, resultCards.firstChild);

            toolbar.querySelector('[data-finder-add-stack]').addEventListener('click', function () {
              var btn = this;
              btn.disabled = true;
              btn.textContent = 'Agregando...';
              addVariantsToCart(stackItems.map(function (i) { return { id: i.id, quantity: 1 }; }))
                .then(function () {
                  window.location.href = buildCartPermalink(stackItems);
                })
                .catch(function () {
                  btn.disabled = false;
                  btn.textContent = 'Agregar stack al carrito';
                  alert('No pudimos agregar el stack. Prueba por WhatsApp.');
                });
            });

            toolbar.querySelector('[data-finder-wa-stack]').addEventListener('click', function () {
              if (typeof window.MG_OPEN_WHATSAPP_SALES === 'function') {
                window.MG_OPEN_WHATSAPP_SALES('custom', 'Hola Asesor MG, hice el Fit Finder y quiero comprar el stack recomendado. ¿Me ayudas con precio y link?');
                return;
              }
              var wa = salesWaNumber();
              window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent('Hola Asesor MG, quiero el stack del Fit Finder. ¿Me mandas link?'), '_blank');
            });
          }
        }

        try {
          localStorage.setItem('mg-finder-result', JSON.stringify(state.answers));
        } catch (e) {}
      });
    }

    btnBack.addEventListener('click', function () {
      if (state.step > 0) { state.step--; renderStep(); }
    });

    btnNext.addEventListener('click', function () {
      if (state.step < state.steps.length - 1) {
        state.step++;
        renderStep();
      } else {
        showResults();
      }
    });

    btnRestart.addEventListener('click', function () {
      state = { step: 0, answers: {}, steps: ['goal', 'level', 'budget'] };
      resultsEl.classList.remove('is-visible');
      quizEl.classList.remove('is-hidden');
      if (prefsBanner) prefsBanner.hidden = true;
      renderStep();
    });

    var prefAnswers = Prefs ? Prefs.toFinderAnswers() : null;
    var params = urlParams();

    if (prefAnswers && Prefs.isComplete(prefAnswers)) {
      if (params.get('autostart') === '1') {
        applyPrefsToState(prefAnswers);
        showResults();
      } else {
        showPrefsBanner(prefAnswers);
        renderStep();
      }
    } else {
      try {
        var legacy = localStorage.getItem('mg-finder-result');
        if (legacy) {
          var parsed = JSON.parse(legacy);
          if (applyPrefsToState(parsed)) showPrefsBanner(parsed);
        }
      } catch (e) {}
      renderStep();
    }
  }

  roots.forEach(function (root) {
    var dataUrl = getDataUrl(root);
    if (!dataUrl) {
      root.querySelector('.mg-finder__options').innerHTML =
        '<p style="color:#888;text-align:center;">Error al cargar. <a href="/pages/contact">Contáctanos</a>.</p>';
      return;
    }

    fetch(dataUrl)
      .then(function (r) {
        if (!r.ok) throw new Error('data fetch failed');
        return r.json();
      })
      .then(function (data) { buildQuiz(root, data); })
      .catch(function () {
        root.querySelector('.mg-finder__options').innerHTML =
          '<p style="color:#888;text-align:center;">Error al cargar. <a href="/pages/contact">Contáctanos</a>.</p>';
      });
  });
})();